var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvitations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16092",
    "data-name": "Group 16092",
    transform: "translate(-175 -275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6864",
    "data-name": "Rectangle 6864",
    width: 50,
    height: 50,
    transform: "translate(175 275)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7262",
    "data-name": "Path 7262",
    d: "M21.544,4.829a2.041,2.041,0,0,0-2.264,0L4.992,14.355a2.04,2.04,0,0,0-.622.654l14.91,9.94a2.041,2.041,0,0,0,2.264,0l14.91-9.94a2.04,2.04,0,0,0-.622-.654ZM40.814,15.7A6.124,6.124,0,0,0,38.1,10.958L23.809,1.432a6.124,6.124,0,0,0-6.794,0L2.727,10.958A6.124,6.124,0,0,0,.01,15.7,2.042,2.042,0,0,0,0,15.966q0,.044,0,.087V34.28A6.124,6.124,0,0,0,6.124,40.4H34.7a6.123,6.123,0,0,0,6.124-6.124V16.053q0-.044,0-.087A2.074,2.074,0,0,0,40.814,15.7Zm-4.073,4.019-8.057,5.371,8.057,5.371Zm-.229,15.5L25,27.548l-1.2.8a6.124,6.124,0,0,1-6.794,0l-1.2-.8L4.311,35.22a2.041,2.041,0,0,0,1.812,1.1H34.7A2.041,2.041,0,0,0,36.513,35.22ZM4.083,30.466l8.057-5.371L4.083,19.723Z",
    transform: "translate(180 279.596)",
    fill: "#0f5a9c",
    fillRule: "evenodd",
    opacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitations);
export default __webpack_public_path__ + "static/media/Invitations.02cb9b17c4dc7b430abc725178a42c2a.svg";
export { ForwardRef as ReactComponent };